import { Raw } from '@/modules/common/helpers/api';
import { OrderBasketParams, RawOmsBasketItem } from '@/modules/marketplace/models';
import { ErrorItem, RawErrorItem } from '@/modules/common/models';
import { OrderIntent, OrderType, TimeInForceType } from '@/modules/marketplace/types/marketplace';
import { RateType } from '@/connect';
import { RawAgreementInfo } from '@/modules/agreements/models';

type Side = 'LOAN' | 'BORROW';

export type RawParseOmsBasketRequest = Raw<ParseOmsBasketRequest>;

export class ParseOmsBasketRequest {
  public file: File;
  public side: Side;
  public orderType: OrderType;
  public orderIntent: OrderIntent;
  public agreementIds: string[];
  public timeInForceType: TimeInForceType;
  public goodTillTime: string | null;
  public rateType: Exclude<keyof typeof RateType, 'UNSPECIFIED'>;
  public active: boolean;
  public allowOddLots: boolean;

  protected constructor(data: RawParseOmsBasketRequest) {
    this.file = data.file;
    this.side = data.side;
    this.orderType = data.orderType;
    this.orderIntent = data.orderIntent;
    this.agreementIds = data.agreementIds;
    this.timeInForceType = data.timeInForceType;
    this.goodTillTime = data.goodTillTime;
    this.rateType = data.rateType;
    this.active = data.active;
    this.allowOddLots = data.allowOddLots;
  }

  public static fromData(data: RawParseOmsBasketRequest): ParseOmsBasketRequest {
    return new ParseOmsBasketRequest(data);
  }

  public static toFormData(model: ParseOmsBasketRequest): FormData {
    const formData = new FormData();
    formData.append('file', model.file);
    formData.append('side', model.side);
    formData.append('orderType', model.orderType);
    formData.append('orderIntent', model.orderIntent);
    formData.append('rateType', model.rateType);
    formData.append('allowOddLots', String(model.allowOddLots));
    model.agreementIds.forEach((item: string, _: number) => {
      formData.append('agreementIds', item);
    });
    formData.append('timeInForceType', model.timeInForceType);
    if (model.goodTillTime !== null) {
      formData.append('goodTillTime', model.goodTillTime);
    }
    return formData;
  }
}

export type RawParseOmsBasketResponse = Raw<
  ParseOmsBasketResponse,
  {
    // always specify existing raw entry types explicitly
    entries: RawOmsBasketItem[];
    agreements: RawAgreementInfo[];
    errors: null | RawErrorItem[];
  }
>;

export class ParseOmsBasketResponse extends OrderBasketParams {
  public errors: null | ErrorItem[];

  protected constructor(data: RawParseOmsBasketResponse) {
    super(data);

    this.errors = data.errors?.map(ErrorItem.fromData) ?? null;
  }

  public static fromData(data: RawParseOmsBasketResponse): ParseOmsBasketResponse {
    return new ParseOmsBasketResponse(data);
  }
}
